module.exports = __webpack_public_path__ + "img/奖品-购买码.38aa31ca.png";